import BaseExecutor from 'services/sports/default/base-executor';
import {NonControlledHitterStackingValidatorBuilder} from 'services/sports/mlb/validator/non-controlled-hitter-stacking-validator-builder';
import {LegacyControlledHitterStackingValidatorBuilder} from 'services/sports/mlb/validator/legacy-controlled-hitter-stacking-validator-builder';
import Action from 'actions';
import BaseValidator from 'services/validations/base-validator';
import OpposingPitchersValidator from 'components/organisms/opposing-pitchers/validators/opposing-pitchers-validator';
import ProjectedOwnershipForceValidator from 'components/organisms/projected-ownership-force/validators/validator';
import LockedGamesValidator from 'services/validations/locked-games-validator';
import {ClassicValidatorBuilder} from 'services/validations/builders/classic-validator-builder';

export default class UserAdjustmentsValidatorClassicBuilder extends BaseExecutor {
    getInterface() {
        const {
            sportConfig,
            nonControlledHitterStacking: {settings: stacking},
            opposingPitchers,
            projectedOwnershipForce,
            playersData: {preparedPlayers, games},
            stacks: {hitters: legacyControlledHitterStacking},
        } = Action.getState();

        const validator = new BaseValidator();

        const classicValidatorBuilder = new ClassicValidatorBuilder().getInterface();
        validator.addSubValidators([classicValidatorBuilder]);

        if (sportConfig.isModeLateswap()) {
            const lockedGamesValidator = new LockedGamesValidator();
            lockedGamesValidator.setDependencies({games});
            validator.addSubValidators([lockedGamesValidator]);
        }

        if (projectedOwnershipForce.isEnabled()) {
            const projectedOwnershipForceValidator = new ProjectedOwnershipForceValidator();
            projectedOwnershipForceValidator.setDependencies({
                sportConfig,
                projectedOwnershipForce,
                players: preparedPlayers.groupedBy.playerId(),
            });
            validator.addSubValidators([projectedOwnershipForceValidator]);
        }

        if (opposingPitchers.isAllowed()) {
            const opposingPitchersValidator = new OpposingPitchersValidator();
            opposingPitchersValidator.setDependencies({opposingPitchers});
            validator.addSubValidators([opposingPitchersValidator]);
        }

        if (stacking.isEnabled()) {
            const nonControlledHitterStackingValidator =
                new NonControlledHitterStackingValidatorBuilder().getInterface();
            validator.addSubValidators([nonControlledHitterStackingValidator]);
        }

        if (legacyControlledHitterStacking.isEnabled()) {
            const legacyControlledHitterStackingValidator =
                new LegacyControlledHitterStackingValidatorBuilder().getInterface();
            validator.addSubValidators([legacyControlledHitterStackingValidator]);
        }

        return validator;
    }
}
